import type { Designer } from "@wix/ambassador-picasso-editor-v1-designer/types";
import { getDesignerTranslationKey } from "@wix/picasso-common";
import { DESIGNER_NAME_TRANSLATION_KEY_SUFFIX } from "../consts";
import type { TFunction } from "react-i18next";

export const getDesignerName = (
  designer: Designer | undefined,
  t: TFunction,
): string => {
  let designerName: string = designer?.name ?? "";

  const designerIdentifier = designer?.styleTags?.[0];
  const designerTranslationKey: string | undefined =
    designerIdentifier &&
    `${getDesignerTranslationKey(designer)}${DESIGNER_NAME_TRANSLATION_KEY_SUFFIX}`;

  if (designerTranslationKey) {
    designerName = t(designerTranslationKey);
  }

  return designerName;
};
